// File: apps/web/src/routes/index.tsx
// Version: 2026.4.2 | Redirects / → /dashboard
// The full dashboard lives at dashboard.tsx — this just redirects.

import { createFileRoute, Navigate } from '@tanstack/react-router';

function IndexRedirect() {
  return <Navigate to="/dashboard" replace />;
}

export const Route = createFileRoute('/')({
  component: IndexRedirect,
});
